import React from 'react';
import { CheckIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { PRODUCT_IMAGE, PRICE } from '../../data/content';
const guarantees = ['Instant access', 'One-time payment', 'Lifetime access', '7-day guarantee'];
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-157" data-mp="hwimphtie8v2">
      <div className="flex w-full items-center justify-center gap-2 bg-ember px-3 py-2.5 text-center" data-id="element-158" data-mp="mu0q6sorbvvo">
        <FlameIcon className="h-4 w-4 shrink-0 text-white" aria-hidden="true" data-id="element-159" data-mp="qvdtow4dnmzf" />
        <p className="text-[11px] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-160" data-mp="qt9hlqwbrho2">
          Launch offer · Lifetime access for only {PRICE.today} USD
        </p>
      </div>

      <div className="mx-auto w-full max-w-5xl px-4 pb-12 pt-8 sm:px-6 sm:pt-12" data-id="element-161" data-mp="10n9w2jdhxz9g">
        <h1 className="text-center font-display text-[38px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-162" data-mp="15ifdp5zv8rrq">
          Master
          <span className="block text-teal-bright" data-id="element-163" data-mp="9oc8wp7gdxj9">Welding System™</span>
        </h1>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-[34px] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl lg:text-[56px]" data-id="element-164" data-mp="4ozlo3co6og5">
          Stop improvising and get{' '}
          <span className="text-teal-bright" data-id="element-165" data-mp="3rtp7w8ll50un">strong, clean weld beads.</span>
        </p>

        <div className="mx-auto mt-6 w-full max-w-lg lg:max-w-2xl" data-id="element-166" data-mp="seanlo5raovv">
          <img src={PRODUCT_IMAGE} alt="Master Welding System complete digital pack: 6 master manuals shown on box, tablet and phone" className="w-full" width={1080} height={1080} data-id="element-167" data-mp="sdiqua0fal40" />
        </div>

        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-168" data-mp="elujek14cktd">
          Forget trial and error, confusing machine settings, and endless hours
          searching through welding videos. Master Welding System™ gives you a
          practical step-by-step system to configure your welder, avoid common
          beginner mistakes, and weld with greater confidence from your very
          first practice sessions.
        </p>

        <p className="mx-auto mt-5 max-w-xl rounded-lg border border-teal/30 bg-teal/[0.08] px-4 py-3 text-center text-[13px] font-bold uppercase leading-snug tracking-wide text-teal-bright sm:text-sm" data-id="element-169" data-mp="2qwnn2yjwv0ap">
          6 Master Manuals + 5 Exclusive Bonuses + Instant digital access
        </p>

        <div className="mx-auto mt-7 w-full max-w-xl" data-id="element-170" data-mp="2mu94mfk5m2jy">
          <CtaButton label="I want the Master Welding System now" data-id="element-171" data-mp="2mw3mtm41jgkc" />
          <div id="hero-cta-anchor" aria-hidden="true" className="h-px w-full" data-id="element-172" data-mp="27y1hp7hd2n0z" />
          <Countdown className="mt-6" data-id="element-173" data-mp="2cvtbk71kgj7t" />
        </div>

        <ul className="mx-auto mt-6 grid w-full max-w-xl grid-cols-2 gap-2" data-id="element-174" data-mp="2cwl75hv5ygy3">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2 rounded-lg border border-white/10 bg-ink-800 px-3 py-2" data-id="element-175" data-mp="642c92qx6zw7">
              <CheckIcon className="h-4 w-4 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-176" data-mp="1vnsfol6rqsf8" />
              <span className="text-[12px] font-semibold leading-tight text-white/85 sm:text-sm" data-id="element-177" data-mp="1qm32ozzzk4oi">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[15px] italic leading-relaxed text-white/55" data-id="element-178" data-mp="20kshul0hzb12">
          More than a course… it’s your practical welding reference guide for
          every time you turn on your machine.
        </p>
      </div>
    </header>;
}